import * as React from 'react'

import styles from './FormButtonWrapper.scss'

const FormButtonWrapper: React.FC = ({ children }) => <div className={styles.buttonWrapper}>{children}</div>

export default FormButtonWrapper
